import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/MailModal.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function MailModal({ isOpen, onClose }) {
  const { t, i18n } = useTranslation();
  
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    subject: '', 
    message: '' 
  });
  const [loading, setLoading] = useState(false);

  // 모달이 열릴 때 작품 문의 기본 템플릿 세팅
  useEffect(() => {
    if (isOpen) {
      setFormData(prev => ({
        ...prev,
        // i18n에 'mail_template_work' 정의 필요 (ex: "작품명/역할/기간 등 상세 내용을 입력해주세요.")
        message: t('mail_template_work') 
      }));
    }
  }, [i18n.language, t, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // 이메일 제목에 [WORK INQUIRY] 머리말 강제 추가
    const finalData = {
      name: formData.name,
      email: formData.email,
      subject: `[작업 문의] ${formData.subject}`,
      message: formData.message
    };

    try {
      const res = await fetch(`${API_BASE}/api/send_mail.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(finalData),
      });
      const data = await res.json();
      if (data.success) {
        alert(t('mail_success'));
        setFormData({ 
          name: '', 
          email: '', 
          subject: '', 
          message: t('mail_template_work') 
        });
        onClose();
      }
    } catch (err) {
      alert(t('mail_error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mail-modal-overlay" onClick={onClose}>
      <div className="mail-modal-content" onClick={e => e.stopPropagation()}>
        <button className="mail-close-x" onClick={onClose}>&times;</button>
        
        {/* 타이틀을 'BUSINESS INQUIRY' 혹은 '작품 문의'로 고정 */}
        <h3>{t('mail_title_work') || 'BUSINESS INQUIRY'}</h3>
        <p className="mail-sub">{t('mail_sub_work')}</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mail-input-group">
            <input 
              type="text" placeholder={t('mail_placeholder_name')} required 
              value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} 
            />
            <input 
              type="email" placeholder={t('mail_placeholder_email')} required 
              value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} 
            />
          </div>

          {/* 카테고리 선택(select) 삭제됨 */}

          <input 
            type="text" placeholder={t('mail_placeholder_subject')} required 
            value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} 
          />
          
          <textarea 
            placeholder={t('mail_placeholder_message')} required rows="10"
            value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} 
          />
          
          <p className="mail-info-text">
            {t('mail_info_work')}
          </p>

          <button type="submit" className="mail-submit-btn" disabled={loading}>
            {loading ? 'SENDING...' : t('mail_send_btn')}
          </button>
        </form>
      </div>
    </div>
  );
}